import { Circle } from '@phosphor-icons/react';

export default Circle;
